import React, { Fragment, useEffect, useState } from "react";
import { zl, isNumber } from "../../../functions/utilities";
import { mm_rrrr_to_date } from "../../../functions/dataFormat";

const WspolnotaRaportZbiorowyTFoot = ( props ) => {

    const { listaMsc, czynszeWspolnota, przelewyWspolnota, visible, czyRok, przelewyRok, czynszeRok,  rozliczenieWody,
        przelewyWidoczne, czynszeWidoczne } = props;

    const [sumaPrzelewyRok, setSumaPrzelewyRok] = useState(0);
    const [sumaCzynszeRok, setSumaCzynszeRok] = useState(0);
    const [rok, setRok] = useState(undefined);

    const sumujNaleznosciMsc = (msc) => {
        let suma = 0;
        const sumaWody = rozliczenieWody?.find( r => r?.miesiac == msc)?.saldoTotal || 0;
        czynszeWspolnota?.forEach( czynsz => {
            czynsz?.grupy_udzial_msc?.forEach( grupa => {
                const mscTemp = grupa?.temp_msc?.find( g => g?.msc === msc)
                const lastTemp = grupa?.temp_msc[grupa?.temp_msc?.length - 1]
                const czynszTemp = mscTemp === undefined && mm_rrrr_to_date(msc) >= mm_rrrr_to_date(grupa?.temp_msc[grupa?.temp_msc?.length - 1].msc) ? lastTemp : mscTemp;
                suma += isNumber(czynszTemp?.czynsz_na_msc) && (czynszTemp?.czynsz_na_msc > 0 || czynszTemp?.czynsz_na_msc == 0 || czynszTemp?.czynsz_na_msc < 0 ) ? czynszTemp?.czynsz_na_msc : 0;
            })
        })
        return suma + sumaWody;
    }

    const sumujWplatyMsc = (msc) => {
        let suma = 0;
        przelewyWspolnota?.forEach(przelew => {
            przelew?.przelewy?.forEach( p => {
                if (p?.msc === msc)
                    suma += p?.kwota;
            })
        })
        return suma;
    }

    const podsumowanieMiesiac = listaMsc?.map( (msc, i) => {
        const sumaWplat = sumujWplatyMsc(msc);
        const sumaNaleznosci = sumujNaleznosciMsc(msc);
        // setSaldoRok( sumaWplat - sumaNaleznosci );
        if (!visible) {

            return (
                <Fragment key={i}>
                </Fragment>
            )
        } else {
            return (
                <Fragment key={i}>
                    <td style={{ whiteSpace: "nowrap", textAlign: "right" }}>
                        {zl(sumaNaleznosci)}
                    </td>
                    <td style={{whiteSpace: "nowrap", textAlign: "right" }}>
                        {zl(sumaWplat)}
                    </td>
                    <td style={{fontWeight: "800", whiteSpace: "nowrap", textAlign: "right" }}>
                        {zl( sumaWplat - sumaNaleznosci)}
                    </td>
                </Fragment>
            )

        }
    })
    
    useEffect( () => {
        const temp = czyRok ? przelewyRok?.reduce((suma, item ) => suma + (Number(item.kwota) || 0),0) : 0;
        setSumaPrzelewyRok(temp);
    }, [czyRok, przelewyRok])

    useEffect( () => {
        const temp = czyRok ? czynszeRok?.reduce((suma, item) => suma + (Number(item.kwota) || 0),0) : 0;
        setSumaCzynszeRok(temp);
    }, [czyRok, czynszeRok])

    useEffect( () => {
        const temp = czyRok ? (
            <td style={{fontWeight: "600", whiteSpace: "nowrap", backgroundColor: "var(--podswietlenie)", textAlign: "right"}}>
                { zl( sumaPrzelewyRok - sumaCzynszeRok )}
            </td>
        ) : <Fragment></Fragment>;
        setRok(temp);
    }, [czyRok, sumaPrzelewyRok, sumaCzynszeRok]);

    const podsumowanieRokTotal = () => {
        
        const sumaPrzelewyWidoczne = przelewyWidoczne?.reduce((suma, item) => {
            return suma + (Number(item.kwota) || 0);
        }, 0);

        const sumaCzynszeWidoczne = czynszeWidoczne?.reduce((suma, item) => {
            return suma + (Number(item.kwota) || 0);
        }, 0);

        return (
            <Fragment>
                <td style={{whiteSpace: "nowrap", backgroundColor: "var(--podswietlenie)", textAlign: "right" }}>
                    {zl(sumaCzynszeWidoczne)}
                </td>
                <td style={{whiteSpace: "nowrap", backgroundColor: "var(--podswietlenie)", textAlign: "right" }}>
                    {zl(sumaPrzelewyWidoczne)}
                </td>
                <td style={{fontWeight: "600", whiteSpace: "nowrap", backgroundColor: "var(--podswietlenie)", textAlign: "right"}}>
                    {zl( (sumaPrzelewyWidoczne - sumaCzynszeWidoczne) + (sumaPrzelewyRok - sumaCzynszeRok) )}                    
                </td>
            </Fragment>
        )
    }

    const podsumowanieFooter = (
        <tr>
            <td colSpan={3} />
            {rok}
            {podsumowanieMiesiac}
            {podsumowanieRokTotal()}
        </tr>
    )

    return (
        <tfoot>
            {podsumowanieFooter}
        </tfoot>
    ) 

}

export default WspolnotaRaportZbiorowyTFoot;